<template>
  <div class="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
    <div class="sm:mx-auto sm:w-full sm:max-w-md">
      <h2 class="mt-6 text-center text-3xl font-extrabold text-gray-900">
        Sign in to your account
      </h2>
      <p class="mt-2 text-center text-sm text-gray-600">
        Or
        <router-link to="/signup" class="font-medium text-blue-600 hover:text-blue-500">
          create a new account
        </router-link>
      </p>
    </div>

    <div class="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
      <div class="bg-white py-8 px-4 shadow-lg sm:rounded-lg sm:px-10">
        <!-- #### THE FIX IS HERE #### -->
        <!-- Connect the form's submit event to the 'login' function -->
        <form @submit.prevent="login" class="space-y-6">
          <div v-if="errorMessage" class="bg-red-50 p-4 rounded-md">
            <p class="text-sm text-red-700">{{ errorMessage }}</p>
          </div>

          <div>
            <label for="email" class="block text-sm font-medium text-gray-700">Email address</label>
            <div class="mt-1">
              <input v-model="email" id="email" name="email" type="email" autocomplete="email" required
                     class="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm">
            </div>
          </div>

          <div>
            <label for="password" class="block text-sm font-medium text-gray-700">Password</label>
            <div class="mt-1">
              <input v-model="password" id="password" name="password" type="password" autocomplete="current-password" required
                     class="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm">
            </div>
          </div>

          <div class="flex items-center justify-end">
            <div class="text-sm">
              <router-link to="/forgot-password" class="font-medium text-blue-600 hover:text-blue-500">
                Forgot your password?
              </router-link>
            </div>
          </div>

          <div>
            <button type="submit"
                    class="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500">
              Sign in
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import axios from '../services/axiosInstance'
import { useUserStore } from '@/stores/user'

const email = ref('')
const password = ref('')
const errorMessage = ref('')
const router = useRouter()
const route = useRoute()
const userStore = useUserStore()

const login = async () => {
  errorMessage.value = ''
  try {
    const response = await axios.post('/login', {
      email: email.value,
      password: password.value
    })

    if (response.status === 200) {
      localStorage.setItem('user-token', 'true')
      await userStore.fetchUser()
      const redirectPath = route.query.redirect || '/testsoverview'
      router.push(redirectPath)
    }
  } catch (error) {
    console.error('Login error details:', error)
    if (error.response && error.response.data) {
      errorMessage.value = error.response.data.message || (typeof error.response.data === 'string' ? error.response.data : 'Invalid email or password.')
    } else {
      errorMessage.value = 'A network error occurred or the server is down.'
    }
  }
}
</script>
